import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Coordinates } from '../global/models/coordinates.models';
import { Browser } from '@capacitor/browser';

const api = environment.googleMapsApiKey;

@Injectable({
  providedIn: 'root'
})
export class MapsService {

  readonly realTimeLocation$ = new BehaviorSubject<Coordinates | null>(null);

  constructor() { }

  init() {
    this._manageRealTimeLocation();
  }

  get apiKey(): string {
    return api;
  }

  get userLocation(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        position => resolve(position),
        err => reject(err));
    });
  }

  openGoogleMaps(coordinates: Coordinates) {
    const url = `https://www.google.com/maps/search/?api=1&query=${coordinates?.lat},${coordinates?.lng}`;
    Browser.open({ url });
  }

  /** Coordenadas de RODABERNAT SL (destino final de las rutas) */
  readonly rodabernatCoords: Coordinates = {
    lat: 39.43300893070491,
    lng: -0.4044778165605761
  };

  /**
   * Abre Google Maps: ubicación actual → paradas → RODABERNAT SL.
   * @param origin Ubicación actual del usuario
   * @param stops Paradas ordenadas (lat,lng)
   */
  openGoogleMapsDirections(origin: Coordinates, stops: Coordinates[]) {
    const originStr = `${origin.lat},${origin.lng}`;
    const destination = `${this.rodabernatCoords.lat},${this.rodabernatCoords.lng}`;
    const waypoints = stops.map(s => `${s.lat},${s.lng}`).join('|');
    const params = new URLSearchParams({
      api: '1',
      origin: originStr,
      destination,
      waypoints,
      travelmode: 'driving'
    });
    const url = `https://www.google.com/maps/dir/?${params.toString()}`;
    Browser.open({ url });
  }

  private _manageRealTimeLocation() {
    navigator.geolocation.watchPosition(position => {
      this.realTimeLocation$.next({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });
    });
  }

}
